import type { TableSort } from './types';

/** The next sort for a click on `field`: a new field starts descending, the same one toggles. */
export function nextSort(current: TableSort | null | undefined, field: string): TableSort {
  if (current?.field === field) {
    return { field, direction: current.direction === 'desc' ? 'asc' : 'desc' };
  }
  return { field, direction: 'desc' };
}
